var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardChart',{attrs:{"input":_vm.chartData,"chartType":"bar","max-width":"100%","loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }